import { useApiData } from '../client';
import type { AvailableModel } from '../../types/media-sim';

export function useAvailableModels() {
  return useApiData<AvailableModel[]>('/media-sim/models');
}
